/* tslint:disable */
// https://material-ui.netlify.com/demos/drawers/#persistent-drawer

import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'

import classNames from 'classnames'
import { withStyles, Theme, createStyles, WithStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import CircularProgress from '@material-ui/core/CircularProgress'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { IState, IFile, IStatus } from './types'
import Tabs from './Tabs'

const drawerWidth = 300

const styles = (theme: Theme) => createStyles({
  root: {
    flexGrow: 1,
    height: '100%',
  },
  appFrame: {
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  'appBarShift-left': {
    marginLeft: drawerWidth,
  },
  'appBarShift-right': {
    marginRight: drawerWidth,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    height: 'calc(100% - 112px)', // horizontal scrollbar hack
    flexGrow: 1,
    minWidth: 0,
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  'content-left': {
    marginLeft: -drawerWidth,
  },
  'content-right': {
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  'contentShift-left': {
    marginLeft: 0,
  },
  'contentShift-right': {
    marginRight: 0,
  },
})

interface IThemeProps extends WithStyles<typeof styles> {
  theme: Theme
}

interface IOwnProps {
  drawerHeader: JSX.Element
  menuItems: JSX.Element
  status: IStatus
  title: string
}

interface PersistentDrawerState {
  open: boolean
}

type Props = IThemeProps & IOwnProps

interface LoadingProps {
  status: IStatus
}

class Loading extends React.Component<LoadingProps> {
  public render () {
    const style: React.CSSProperties = {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
    }
    return (
      <div style={style}>
        <CircularProgress style={{ margin: '15px' }}/>
        <Typography variant={'headline'}>{
          _
            .chain(this.props.status)
            .toLower()
            .upperFirst()
            .concat('...')
            .value()
        }</Typography>
      </div>
    )
  }
}

class PersistentDrawer extends React.Component<Props, PersistentDrawerState> {
  state = {
    open: true,
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    this.setState({ open: false })
  }

  render() {
    const {
      classes,
      drawerHeader, // open logs button
      menuItems, // things to go in the menu
      status,
      title, // file name
    } = this.props
    const { open } = this.state

    const drawer = (
      <Drawer
        variant="persistent"
        anchor={'left'}
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          {drawerHeader}
          <IconButton onClick={this.handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        {status === 'BROWSING' && menuItems}
        {status === 'EXTRACTING' && <Loading status={'EXTRACTING'}/>}
        {status === 'ANALYZING' && <Loading status={'ANALYZING'}/>}
        {status === 'DOWNLOADING' && <Loading status={'DOWNLOADING'}/>}
      </Drawer>
    )

    return (
      <div className={classes.root}>
        <div className={classes.appFrame}>
          <AppBar
            className={classNames(classes.appBar, {
              [classes.appBarShift]: open,
              [classes[`appBarShift-left`]]: open,
            })}
          >
            <Toolbar disableGutters={!open}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(classes.menuButton, open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="title" color="inherit" noWrap>
                {title}
              </Typography>
            </Toolbar>
          </AppBar>
          {drawer}
          <main
            className={classNames(classes.content, classes['content-left'], {
              [classes.contentShift]: open,
              [classes['contentShift-left']]: open,
            })}
          >
            <div className={classes.drawerHeader} />
            <Tabs /> { /* tab component, managing editor, charts etc */ }
          </main>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IState) => {
  const fileName = (state.files.filter((file: IFile) => file.open)[0] || {}).name || 'Open a file'
  const { status, zipName } = state
  const title = zipName ? [zipName, fileName].join(' - ') : fileName
  return {
    status,
    title,
  }
}

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(PersistentDrawer))



// WEBPACK FOOTER //
// ./src/Sidebar.tsx